import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useRouter } from 'vue-router';
import { store } from '../utils/store';
import { getColorPairById } from '../utils/colorGenerator';
export default {
  __name: 'VideoTags',
  setup(__props) {
    const router = useRouter();
    const list = ['自慰', '学生', '极品', '内射', '少女', '人妻', '萝莉', '巨乳', '乱伦', '高潮', '少妇', '女神', '黑丝', '调教', '无套', '真实', '美女', '中出', '大奶', '按摩', '白虎', '颜值', '诱惑', '大小', '淫荡', '老师', '口交'];
    list.slice(0, 7);
    const query = item => {
      router.push({
        path: "more",
        query: {
          keyword: item
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_van_tag = _resolveComponent("van-tag");
      const _component_AlternatingMarquee = _resolveComponent("AlternatingMarquee");
      return _openBlock(), _createBlock(_component_AlternatingMarquee, {
        items: list,
        rows: 3,
        durations: [26, 32, 29],
        gap: 12,
        rowGap: 10,
        pauseOnHover: true,
        edgeFade: 0.4
      }, {
        item: _withCtx(({
          item
        }) => [_createVNode(_component_van_tag, {
          class: "chip-tag",
          type: "primary",
          color: _unref(getColorPairById)(item).bgColor,
          onClick: $event => query(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(store).isDev() ? 'title' : item), 1)]),
          _: 2
        }, 1032, ["color", "onClick"])]),
        _: 1
      });
    };
  }
};